import { customAlphabet } from 'nanoid';

export const generateId = customAlphabet('0123456789abcdefghijklmnopqrstuvwxyz', 25);

// ex: SGM_5fnjqaix3cwu7xwnisioz16wz
export const generateExecutionId = () => {
  return `SGM_${generateId()}`;
};
